export const version = "ethers/5.5.1";
//# sourceMappingURL=_version.js.map